import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Segment } from '../../services/analytics-services/segment';
import Global from '../../store/global-selectors';
import { EXPERIMENT_VIEWED } from '../../constants/analytics-events';
import { ExperimentGroupVariations } from '../experiment/experiments';
import { useEnableRateShopperFreemium } from '../../feature-flags/hooks/use-enable-rate-shopper-freemium';
import { ACCESS_LEVELS, useRequiresRateShopperAccessLevel } from '../use-has-rate-shopper-access-level';

const GROW_709 = 'GROW_709';

export const useTrackGrow709Experiment = () => {
  const sellerId = useSelector(Global.selectSellerSellerId)?.toString();
  const userId = useSelector(Global.selectUserCurrentUserId);

  const hasPremiumAccess = useRequiresRateShopperAccessLevel(ACCESS_LEVELS.PREMIUM);
  const variant =
    useEnableRateShopperFreemium() && !hasPremiumAccess ? ExperimentGroupVariations.VARIANT : ExperimentGroupVariations.CONTROL;

  return useCallback(async () => {
    Segment.trackEvent(EXPERIMENT_VIEWED, {
      experiment_id: GROW_709,
      group_variation: variant,
      seller_id: sellerId,
      user_id: userId,
      enrollment_date: new Date(),
    });
  }, [sellerId, userId, variant]);
};
